import { GlobalRouter } from "@routes/index";

import "@styles/index.scss";
import "antd/dist/antd.less";
function App() {
  return (
    <>
      <GlobalRouter />
    </>
  );
}

export default App;
